export default {
      id: "oc-icon_more-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_more",
      toString: function () {
        return this.url;
      }
    }